// context
import { useAuth } from '@/auth/AuthContext';

// project
import NotificationSnackbar from './NotificationSnackbar';

export default function GlobalNotifier() {
  const { notification, setNotification } = useAuth();

  return (
    <NotificationSnackbar
      open={notification.open}
      message={notification.message}
      severity={notification.severity}
      onClose={() => setNotification((prev) => ({ ...prev, open: false }))}
    />
  );
}
